const CATEGORY_HEX: Record<string, string> = {
  // Real Estate
  Properties: "#8a62c5",

  // Financial Accounts
  "Bank accounts": "#ce5211",
  "Brokerage accounts": "#1e90d9",
  "Tax-advantaged savings": "#06b6d4",
  "Retirement accounts": "#259850",
  "Crypto accounts": "#f97316",
  NFTs: "#a855f7",
  "Other digital assets": "#6366f1",

  // Insurance
  "Life insurance": "#f5717f",
  "Long-term care insurance": "#ec4899",
  "Annuity contracts": "#84cc16",

  // Tangible Personal Property
  Vehicles: "#39c9b7",
  "Safe or safety deposit box": "#94a3b8",
  Valuables: "#eab308",

  // Business Interests
  "LLC or partnership interest": "#f59e0b",
  "Stock in a private company": "#d97706",
  "Sole proprietorship": "#b45309",

  // Other Assets
  Receivables: "#22d3ee",
  "Work-related pay and shares": "#10b981",
  "Royalties and Intellectual Property": "#8b5cf6",
  "Prepaid Services and Credits": "#14b8a6",

  // Debts and Liabilities
  "Unsecured Debts": "#ef4444",
  "Secured debts": "#dc2626",

  // Ongoing Estate Expenses
  "Ongoing Estate Expenses": "#3b82f6",

  // Other Debts
  "Contingent Liabilities": "#6b7280",
  "Tax Liabilities": "#991b1b",
};

const DEFAULT_HEX = "#9ca3af";

export function getCategoryHex(category: string): string {
  return CATEGORY_HEX[category] ?? DEFAULT_HEX;
}

const GROUP_HEX: Record<string, string> = {
  "Real Estate": "#8a62c5",
  "Financial Accounts": "#1e90d9",
  Insurance: "#f5717f",
  "Tangible Personal Property": "#39c9b7",
  "Business Interests": "#f59e0b",
  "Other Assets": "#22d3ee",
  "Debts and Liabilities": "#ef4444",
  "Ongoing Estate Expenses": "#fb923c",
  "Other Debts": "#9ca3af",
};

export function getGroupHex(group: string): string {
  return GROUP_HEX[group] ?? DEFAULT_HEX;
}

export const DEBT_SEGMENT_HEX = "#e7e5e4";

interface CategoryStyle {
  bgClass: string;
  textClass: string;
}

const REAL_ESTATE_STYLE: CategoryStyle = { bgClass: "bg-purple-100", textClass: "text-purple-600" };
const FINANCIAL_STYLE: CategoryStyle = { bgClass: "bg-green-100", textClass: "text-green-800" };
const INSURANCE_STYLE: CategoryStyle = { bgClass: "bg-teal-50", textClass: "text-teal-600" };
const ROSE_STYLE: CategoryStyle = { bgClass: "bg-rose-50", textClass: "text-rose-400" };
const VEHICLE_STYLE: CategoryStyle = { bgClass: "bg-blue-50", textClass: "text-blue-600" };
const BUSINESS_STYLE: CategoryStyle = { bgClass: "bg-blue-100", textClass: "text-blue-600" };
const YELLOW_STYLE: CategoryStyle = { bgClass: "bg-yellow-50", textClass: "text-yellow-600" };
const DEBTS_STYLE: CategoryStyle = { bgClass: "bg-orange-50", textClass: "text-orange-500" };

const CATEGORY_STYLES: Record<string, CategoryStyle> = {
  // Real Estate
  Properties: REAL_ESTATE_STYLE,

  // Financial Accounts
  "Bank accounts": FINANCIAL_STYLE,
  "Brokerage accounts": FINANCIAL_STYLE,
  "Tax-advantaged savings": FINANCIAL_STYLE,
  "Retirement accounts": FINANCIAL_STYLE,
  "Crypto accounts": FINANCIAL_STYLE,
  NFTs: FINANCIAL_STYLE,
  "Other digital assets": FINANCIAL_STYLE,

  // Insurance
  "Life insurance": INSURANCE_STYLE,
  "Long-term care insurance": INSURANCE_STYLE,
  "Annuity contracts": INSURANCE_STYLE,

  // Tangible Personal Property
  Vehicles: VEHICLE_STYLE,
  "Safe or safety deposit box": REAL_ESTATE_STYLE,
  Valuables: ROSE_STYLE,

  // Business Interests
  "LLC or partnership interest": BUSINESS_STYLE,
  "Stock in a private company": BUSINESS_STYLE,
  "Sole proprietorship": BUSINESS_STYLE,

  // Other Assets
  Receivables: YELLOW_STYLE,
  "Work-related pay and shares": YELLOW_STYLE,
  "Royalties and Intellectual Property": YELLOW_STYLE,
  "Prepaid Services and Credits": YELLOW_STYLE,

  // Debts and Liabilities
  "Unsecured Debts": DEBTS_STYLE,
  "Secured debts": DEBTS_STYLE,

  // Ongoing Estate Expenses
  "Ongoing Estate Expenses": YELLOW_STYLE,

  // Other Debts
  "Contingent Liabilities": ROSE_STYLE,
  "Tax Liabilities": ROSE_STYLE,
};

const DEFAULT_CATEGORY_STYLE: CategoryStyle = {
  bgClass: "bg-gray-400/10",
  textClass: "text-gray-400",
};

export function getCategoryStyle(category: string): CategoryStyle {
  return CATEGORY_STYLES[category] ?? DEFAULT_CATEGORY_STYLE;
}
